var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgSentimentDissatisfied = function SvgSentimentDissatisfied(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#E95D5D",
    clipPath: "url(#sentiment_dissatisfied_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M16.792 11.917a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25M9.208 11.917a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M12.99 2.167C7.01 2.167 2.166 7.02 2.166 13s4.842 10.833 10.822 10.833c5.991 0 10.844-4.853 10.844-10.833S18.98 2.167 12.99 2.167m.01 19.5A8.664 8.664 0 0 1 4.333 13 8.664 8.664 0 0 1 13 4.333 8.664 8.664 0 0 1 21.667 13 8.664 8.664 0 0 1 13 21.667m0-6.5a5.95 5.95 0 0 0-5.547 3.791h1.81A4.32 4.32 0 0 1 13 16.792c1.603 0 2.98.877 3.738 2.166h1.809A5.95 5.95 0 0 0 13 15.167"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "sentiment_dissatisfied_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
};
export default SvgSentimentDissatisfied;